import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const pageList = (page, totalPages) => {
  const pages = new Set([1, totalPages, page - 1, page, page + 1]);
  const sorted = [...pages].filter(p => p >= 1 && p <= totalPages).sort((a, b) => a - b);
  const out = [];
  sorted.forEach((p, i) => {
    if (i > 0 && p - sorted[i - 1] > 1) out.push(`gap-${p}`);
    out.push(p);
  });
  return out;
};

export const AdminPagination = ({ page, pageSize, total, onChange }) => {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (total <= pageSize) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  const navCls = 'inline-flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-bold border border-gray-300 text-[#172554] bg-white hover:border-[#172554] disabled:opacity-40 disabled:cursor-not-allowed transition-colors';
  return (
    <div className="flex items-center justify-between flex-wrap gap-3 mt-4 pt-4 border-t" data-testid="booking-pagination">
      <div className="text-xs text-[#64748B] font-bold" data-testid="booking-pagination-range">
        {from}–{to} / {total.toLocaleString('en-IN')}
      </div>
      <div className="flex items-center gap-1.5">
        <button className={navCls} disabled={page <= 1} onClick={() => onChange(page - 1)} data-testid="booking-pagination-prev">
          <ChevronLeft className="w-3.5 h-3.5" /> પાછળ
        </button>
        {pageList(page, totalPages).map(p => typeof p === 'string' ? (
          <span key={p} className="px-1 text-[#64748B]">…</span>
        ) : (
          <button
            key={p}
            onClick={() => onChange(p)}
            data-testid={`booking-pagination-page-${p}`}
            className={`min-w-[32px] px-2 py-1.5 rounded-lg text-xs font-bold border transition-colors ${p === page ? 'bg-[#172554] text-white border-[#172554]' : 'bg-white text-[#172554] border-gray-300 hover:border-[#172554]'}`}
          >
            {p}
          </button>
        ))}
        <button className={navCls} disabled={page >= totalPages} onClick={() => onChange(page + 1)} data-testid="booking-pagination-next">
          આગળ <ChevronRight className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};
